/**
 * Obtenir l'URL de base du site selon l'environnement (sans slash final).
 * Évite les doubles barres dans `${getBaseUrl()}/${locale}/...` si VITE_FRONTEND_URL finit par /.
 */
function isLocalhostUrl(value: string): boolean {
  return /localhost|127\.0\.0\.1/i.test(value)
}

export function getBaseUrl(): string {
  let url: string
  const viteFrontend = import.meta.env.VITE_FRONTEND_URL as string | undefined

  if (viteFrontend && !isLocalhostUrl(viteFrontend)) {
    url = viteFrontend
  } else if (import.meta.env.PROD) {
    // Build prod : jamais localhost dans og:image / canonical (même si .env.local surcharge).
    url = 'https://www.postdev.fr'
  } else {
    const environment = import.meta.env.MODE || 'development'
    if (environment === 'preproduction') {
      url = 'https://preprod.postdev.fr'
    } else if (typeof window !== 'undefined') {
      const origin = window.location.origin
      url = isLocalhostUrl(origin) ? origin : 'http://localhost:3000'
    } else {
      url = viteFrontend && isLocalhostUrl(viteFrontend) ? viteFrontend : 'http://localhost:3000'
    }
  }

  return url.replace(/\/+$/, '')
}

import { defaultSiteTitle, seoTranslations } from './seo.i18n'
import { ORG_SAME_AS } from './organization'

export const defaultSeoConfig = {
  title: defaultSiteTitle,
  description: seoTranslations.fr.description,
  twitterCard: 'summary_large_image',
  get ogImage() {
    return `${getBaseUrl()}/og-image.jpg`;
  },
  get canonicalUrl() {
    return getBaseUrl();
  },
  get organization() {
    const baseUrl = getBaseUrl();
    return {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'PostDev',
      url: baseUrl,
      logo: `${baseUrl}/logo.png`,
      sameAs: [...ORG_SAME_AS]
    };
  }
};
